// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"5b729cf7","963":"65c59be6"}[chunkId] + ".chunk.js";
};